module.exports = __webpack_public_path__ + "img/atramex_login.fbf3914.png";